import { FillPattern } from "../../types/floorplannerTypes";
import { FILL_PATTERN_OPTIONS } from "../../utils/fillPatterns";

/**
 * Floor-pattern order for the room picker: None, then common interior floors.
 * Labels come from the shared FILL_PATTERN_OPTIONS catalog.
 */
const ROOM_FLOOR_PATTERN_ORDER: Array<FillPattern | undefined> = [
  undefined, // None
  "herringbone2", // Herringbone
  "herringbone", // Chevron
  "chevron", // Parquet version
  "chevronLines",
  "wood",
  "woodContour",
  "basketweave",
  "runningPavers",
  "staggeredPavers",
  "brick",
  "stoneLarge",
  "stoneSmall",
  "pavementGrid",
  "paversOctagon",
  "concrete",
  "concreteBlock",
  "cement",
  "sand",
  "earth",
  "grass",
  "steel",
  "glass",
  "rcc",
];

export const ROOM_FLOOR_PATTERN_OPTIONS: {
  value: FillPattern | undefined;
  label: string;
}[] = ROOM_FLOOR_PATTERN_ORDER.map((value) => {
  const match = FILL_PATTERN_OPTIONS.find((option) => option.value === value);
  return match ?? { value, label: value ?? "None" };
});

/** Default floor pattern for newly created rooms. */
export const DEFAULT_ROOM_FLOOR_PATTERN: FillPattern = "herringbone2";
